/* eslint-disable */
import { protoLib as lib } from '@tock/coretypes';

import consumerProtoDefs from '@tock/protos/dist/consumer.json';

lib
  .define('tocktix.proto.consumer')
  .addJSON(consumerProtoDefs.nested.tocktix.nested.proto.nested.consumer.nested);
const resolvedRoot = lib.resolveAll();

export default {
  ...resolvedRoot.lookup('tocktix.proto.consumer'),
} as any;
